import BaseService from '@/services/BaseService';
const FINANCIAL_ASSETS_DASHBOARD_PATH = 'exposure/financial-assets/dashboard';
const FINANCIAL_ASSETS_AS_OF_DATES_PATH = 'exposure/financial-assets/as-of-dates';

export type FinancialAssetsFacilityRow = {
  reportDate: string;
  facilityName: string;
  facilityCode: string;
  businessLine: string;
  maturityDate: string;
  assetClasses: string;
  assetSubClasses: string;
  fundingVehicles: string;
  lenderOfRecords: string;
  marketIndex: string;
  creditLimit: number;
  upb: number;
  committedAmount: number;
  netCommittedAmount: number;
  netOutstanding: number;
  participation: number;
  grossOutstanding: number;
  marketValue: number;
  mtm: number;
  vhSpread: number;
  facilityRating: string;
  facilityRatingDate: string;
  dealName: string;
  category: string;
  subCategory: string;
  team: string;
  gp: string;
  geographicFocus: string;
};

export type FinancialAssetsKpis = {
  totalCreditLimit: number;
  totalNetCommitted: number;
  totalNetOutstanding: number;
  utilizationPct: number;
  wtdAvgRatingLabel: string | null;
  wtdAvgRatingValue: number | null;
};

export type FinancialAssetsDashboardResponse = {
  sourceFile: string;
  reportDate: string;
  facilityCount: number;
  kpis: FinancialAssetsKpis;
  records: FinancialAssetsFacilityRow[];
};

function stringArrayFromBody(body: Record<string, unknown>, ...keys: string[]): string[] {
  for (const key of keys) {
    const raw = body[key];
    if (Array.isArray(raw)) {
      return raw.filter((value): value is string => typeof value === 'string');
    }
  }
  return [];
}

export class FinancialAssetsExposureService extends BaseService {
  constructor() {
    super('/api/digitalconnect-service');
  }

  fetchFinancialAssetsExposureDashboard = async (asOfDate?: string) => {
    return this.get<FinancialAssetsDashboardResponse>({
      path: FINANCIAL_ASSETS_DASHBOARD_PATH,
      params: asOfDate ? { asOfDate } : undefined,
    } as never);
  };

  fetchFinancialAssetsExposureAsOfDates = async () => {
    const raw = await this.get<unknown>({ path: FINANCIAL_ASSETS_AS_OF_DATES_PATH } as never);
    if (raw && typeof raw === 'object' && !(raw instanceof Response)) {
      return stringArrayFromBody(raw as Record<string, unknown>, 'asOfDates', 'AsOfDates');
    }
    return [];
  };
}
